import { render, staticRenderFns } from "./JiaYing.vue?vue&type=template&id=484bdbdc&scoped=true&"
import script from "./JiaYing.vue?vue&type=script&lang=js&"
export * from "./JiaYing.vue?vue&type=script&lang=js&"
import style0 from "./JiaYing.vue?vue&type=style&index=0&id=484bdbdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484bdbdc",
  null
  
)

export default component.exports